import { createContext, useContext, useState } from "react";

export const translations = {
  en: {
    nav_plans: "Plans",
    nav_calculator: "Calculator",
    nav_dsa: "DSA Partner",
    nav_contact: "Contact",
    nav_login: "Login",
    nav_join: "Join Now",
    nav_dashboard: "My Dashboard",
    nav_logout: "Logout",
    hero_eyebrow: "Matrix Works Service Pvt. Ltd. · Ahmedabad",
    hero_l1: "Best Investment",
    hero_l2: "Planning for a",
    hero_l3: "Golden Future",
    hero_sub: "Financial security, reliable returns and a true partner for your future. You invest yourself, track growth live, and withdraw on time.",
    hero_cta1: "Explore Plans",
    hero_cta2: "Try the Calculator",
    stat_years: "Years of Trust",
    stat_clients: "Active Clients",
    stat_funds: "Funds Managed",
    stat_turnover: "Daily Avg. Turnover",
    marquee_1: "100% Real-Time Tracking",
    marquee_2: "Transparent Accounting",
    marquee_3: "On-Time Withdrawals",
    marquee_4: "Written MOU Agreement",
    marquee_5: "Daily Live Growth",
    plans_eyebrow: "Investment Plans",
    plans_title: "Five ways to grow your wealth",
    plans_sub: "From a small daily saving to a high-return monthly income — every plan is backed by a written agreement.",
    p1_name: "Daily Recurring Plan",
    p1_tag: "30 Days · 10% Net Profit",
    p1_desc: "Start with just ₹50 per day. Lump-sum deposit option within 7 days. Full withdrawal with interest on day 30, straight to your bank.",
    p2_name: "Daily ROI Plan",
    p2_tag: "1–2% Daily · Capital Back",
    p2_desc: "Fixed daily income credited to your account. Minimum withdrawal ₹500. Original capital fully returned at maturity.",
    p3_name: "Monthly ROI Plan",
    p3_tag: "11–15% Monthly · 12 Months",
    p3_desc: "Invest once and receive pension-like income every month. Entire capital returned in the 12th month.",
    p4_name: "Fixed Deposit",
    p4_tag: "6 Months · Secure Growth",
    p4_desc: "Fixed-term capital growth with written assurance and a complete legal agreement (MOU).",
    p5_name: "Gold Recurring Plan",
    p6_name: "Investment with Loan Plan",
    p6_tag: "Daily ROI + Loan facility",
    p6_desc: "Earn 1% daily for 90 days (2% from ₹1 lakh) with capital back — and unlock a loan up to 3x your investment in just 10 days at 11% EMI.",
    p5_tag: "Lowest Gold Price",
    p5_desc: "Build savings in gold at the best price with a smart, secure recurring plan.",
    plan_cta: "Start this plan",
    calc_eyebrow: "Plan Calculator",
    calc_title: "See your returns before you invest",
    calc_sub: "Move the slider and watch your projected income, profit and total return update live.",
    calc_daily_deposit: "Daily deposit",
    calc_investment: "Investment amount",
    calc_duration: "Duration",
    calc_days: "days",
    calc_day: "day",
    calc_months: "months",
    calc_month: "month",
    calc_rate: "Return rate",
    calc_daily_income: "Daily income",
    calc_monthly_income: "Monthly income",
    calc_total_deposit: "Total deposit",
    calc_profit: "Total profit",
    calc_total_return: "Total return",
    calc_capital_back: "Capital returned at maturity",
    calc_cta: "Start investing now",
    dsa_eyebrow: "DSA Partner Program",
    dsa_title: "Build your own business with Matrix Works",
    dsa_sub: "Get your unique DSA code, track every pay-out live, and earn up to 14% as your team grows.",
    dsa_join: "Join as DSA Partner",
    dsa_f1: "Separate DSA Code",
    dsa_f2: "Live Pay-Out Tracking",
    dsa_f3: "Renewal Bonus",
    dsa_f4: "1% Team Referral",
    slab_business: "Monthly Business",
    slab_payout: "Pay-Out",
    slab_renewal: "Renewal",
    slab_extra: "Extra",
    slab_total: "Total",
    slab_upto: "Up to",
    slab_above: "Above",
    sec_eyebrow: "100% Security",
    sec_title: "Your money, protected in writing",
    sec_sub: "We don't just make promises — we hand you a fully secure, transparent system.",
    sec1_t: "Complete Agreement (MOU)",
    sec1_d: "A written legal contract for every plan you choose.",
    sec2_t: "Security Blank Cheque",
    sec2_d: "Provided by the company for your investment security.",
    sec3_t: "Live Dashboard",
    sec3_d: "Daily growth visible live on your mobile or computer.",
    sec4_t: "On-Time Withdrawal",
    sec4_d: "Funds credited directly to your bank account on schedule.",
    trust_quote: "Invest and sleep peacefully. Whatever returns we commit, we give them to you in writing — your investment stays in your own hands.",
    trust_name: "Matrix Works Promise",
    contact_eyebrow: "Contact Us",
    contact_title: "Start investing today, secure a bright future",
    contact_sub: "Visit our office or call us — our team will explain every plan in simple language.",
    contact_call: "Call Us",
    contact_office: "Office Address",
    footer_tag: "Financial Security · Reliable Returns · Your True Companion",
    footer_rights: "© 2026 Matrix Works Service Pvt. Ltd. All rights reserved.",
    login_title: "Welcome back",
    login_sub: "Login to view your plans and day-to-day passbook.",
    login_investor_title: "Investor Login",
    login_dsa_title: "DSA Partner Login",
    login_dsa_sub: "Login to your referral and business dashboard.",
    login_dsa_badge: "DSA Partner Portal",
    login_dsa_new: "New DSA partner?",
    login_dsa_link: "DSA Partner? Login here",
    login_investor_link: "Investor? Login here",
    login_wrong_dsa: "This is not a DSA partner account. Please use the Investor Login page.",
    login_wrong_investor: "This is a DSA partner account. Please use the DSA Partner Login page.",
    nav_investor_login: "Investor Login",
    nav_dsa_login: "DSA Login",
    loan_sec_title: "Investment with Loan Plan",
    loan_sec_sub: "Invest regularly, earn higher returns and get a loan facility for your financial needs.",
    loan_hl_days: "90-day ROI returns",
    loan_hl_loan: "Loan in just 10 days",
    loan_hl_emi: "EMI only 11%",
    loan_hl_tenure: "12 / 24 / 36 / 60 month tenure",
    loan_col_deposit: "Deposit (₹)",
    loan_col_daily: "Daily ROI (₹)",
    loan_col_loan: "Loan Amount (₹)",
    loan_col_tenure: "Tenure",
    loan_col_emi: "Monthly EMI (₹)",
    loan_col_profit: "Total Profit (₹)",
    loan_col_repay: "Loan Repay Total (₹)",
    loan_col_left: "Balance After 90 Days (₹)",
    loan_months: "months",
    loan_note: "Note: Terms and conditions apply as per company policy. For more information contact your nearest branch.",
    calc_loan_upto: "Loan eligibility (up to)",
    d_loan_title: "Loan Facility",
    d_loan_apply: "Apply for Loan",
    d_loan_eligible: "Loan Eligibility",
    d_loan_available: "Available to Borrow",
    d_loan_need_plan: "Invest in the Investment with Loan Plan to unlock your loan facility (loan in just 10 days).",
    d_loan_none: "No loan requests yet",
    d_loan_requests: "My Loan Requests",
    d_emi: "Monthly EMI",
    d_tenure: "Tenure",
    d_months: "months",
    msg_loan_submitted: "Loan request submitted for approval",
    tab_loans: "Loans",
    adm_no_loans: "No loan requests",
    adm_emi_tenure: "EMI / Tenure",
    msg_loan_updated: "Loan status updated",
    d_emi_pay: "Pay EMI",
    d_emi_schedule: "EMI Schedule",
    d_emi_paid: "Paid",
    d_emi_verification: "Verifying",
    d_emi_pending: "Pending",
    d_emi_overdue: "Overdue",
    d_emi_progress: "EMIs paid",
    d_emi_due: "Due",
    msg_emi_submitted: "EMI payment submitted for verification",
    adm_emi_verifications: "EMI Payment Verifications",
    adm_emi_no: "EMI #",
    msg_emi_updated: "EMI status updated",
    dsad_share_link: "Your Referral Link",
    dsad_copy_link: "Copy Link",
    dsad_share_wa: "Share on WhatsApp",
    dsad_share_msg: "Join Matrix Works Gold — invest and earn daily returns, plus loan facility. Register with my referral link:",
    msg_link_copied: "Referral link copied",
    msg_photo_uploaded: "Photo uploaded",
    dsad_id_card: "My ID Card",
    dsad_id_sub: "Upload your photo and download your official Matrix Works DSA ID card.",
    dsad_upload_photo: "Upload Photo",
    dsad_download_id: "Download ID Card",
    dsad_photo_required: "Upload your photo first",
    d_photo: "Photo",
    adm_view: "View",
    adm_profile_title: "Investor Profile",
    adm_joined: "Joined",
    adm_balance: "Balance",
    adm_plans: "Plans",
    adm_loans: "Loans",
    adm_payments: "Deposits & Withdrawals",
    adm_passbook_recent: "Recent Passbook Entries",
    register_title: "Create your account",
    register_sub: "Register as a customer or DSA partner. Admin will approve your account.",
    register_sub_customer: "Create your investor account — log in instantly and start investing.",
    d_dash_sub: "View your plans and day-to-day passbook.",
    d_passbook: "Passbook",
    d_balance: "Current Balance",
    d_invested: "Total Invested",
    d_returns: "Total Returns",
    d_active: "Active Plans",
    d_date: "Date",
    d_description: "Description",
    d_credit: "Credit",
    d_debit: "Debit",
    d_amount: "Amount",
    d_status: "Status",
    d_plan: "Plan",
    d_rate: "Rate",
    d_expected: "Expected Total",
    d_my_investments: "My Investments",
    d_add_deposit: "Add Deposit",
    d_withdraw: "Request Withdrawal",
    d_ac_holder: "Account Holder Name",
    d_ac_number: "Account Number",
    d_bank_name: "Bank Name",
    d_ifsc: "IFSC Code",
    d_new_investment: "Start New Investment",
    d_full_name: "Full Name",
    d_email: "Email ID",
    d_mobile: "Mobile No",
    d_submit: "Submit",
    d_note: "Note (optional)",
    d_no_entries: "No entries yet",
    d_select_plan: "Select a plan",
    d_download_pdf: "Download PDF",
    d_day_to_day: "Day to Day",
    k_investment: "Plan Activated",
    k_deposit: "Deposit",
    k_return: "Daily Return",
    k_withdrawal: "Withdrawal",
    k_adjustment: "Adjustment",
    msg_inv_submitted: "Investment request submitted for approval",
    msg_dep_submitted: "Deposit submitted for admin approval",
    msg_wd_submitted: "Withdrawal request submitted",
    dsad_title: "DSA Business Page",
    dsad_sub: "Your own business dashboard — team, volume and pay-outs.",
    dsad_your_code: "Your DSA Code",
    dsad_share_hint: "Share this code with customers — their business counts towards your slab.",
    dsad_copy: "Copy Code",
    dsad_copied: "DSA code copied",
    dsad_team_business: "Team Business",
    dsad_current_slab: "Current Slab",
    dsad_est_payout: "Estimated Pay-Out",
    dsad_team_members: "Team Members",
    dsad_breakdown: "Pay-Out Breakdown",
    dsad_my_team: "My Team",
    dsad_slab_progress: "Slab Progress",
    dsad_slabs_title: "DSA Business Slabs",
    dsad_you: "You",
    dsad_team_empty: "No team members yet — share your DSA code to grow your team.",
    d_name: "Name",
    d_phone: "Phone",
    d_business: "Business",
    adm_title: "Admin Panel",
    adm_sub: "Manage approvals, plans, deposits and daily returns.",
    tab_overview: "Overview",
    tab_users: "Users",
    tab_investments: "Investments",
    tab_deposits: "Deposits",
    tab_withdrawals: "Withdrawals",
    tab_passbook: "Passbook",
    adm_total_business: "Total Business",
    adm_customers: "Customers",
    adm_dsa_partners: "DSA Partners",
    adm_active_plans: "Active Plans",
    adm_pending_users: "Pending Users",
    adm_pending_plans: "Pending Plans",
    adm_pending_deposits: "Pending Deposits",
    adm_pending_withdrawals: "Pending Withdrawals",
    adm_credit_btn: "Credit Today's Daily Returns",
    adm_approve: "Approve",
    adm_reject: "Reject",
    adm_no_users: "No users",
    adm_no_investments: "No investments",
    adm_no_deposits: "No deposits",
    adm_no_withdrawals: "No withdrawals",
    adm_customer: "Customer",
    adm_principal: "Principal",
    adm_action: "Action",
    adm_email: "Email",
    adm_role: "Role",
    adm_dsa_code: "DSA Code",
    adm_manual_title: "Add Manual Passbook Entry",
    adm_amount_hint: "Amount (₹) — negative for debit",
    adm_select_customer: "Select customer",
    adm_add_entry: "Add Entry",
    adm_note: "Note",
    msg_success: "Done successfully",
    msg_credited_prefix: "Credited daily returns to",
    msg_credited_suffix: "active plan(s)",
    msg_entry_added: "Passbook entry added",
    gallery_eyebrow: "Official Plan Charts",
    gallery_title: "Rate charts, straight from the company",
    gallery_sub: "Official Matrixworks Gold posters for each plan — click any chart to view it full size.",
    k_capital_return: "Capital Refund",
    d_maturity: "Maturity",
    fp_title: "Forgot password?",
    fp_sub: "Enter your registered email — we will send you a reset link.",
    fp_send: "Send Reset Link",
    fp_sent: "If this email is registered, a reset link has been sent. Please check your inbox.",
    fp_back: "Back to Login",
    rp_title: "Reset password",
    rp_sub: "Choose a new password for your account.",
    rp_new: "New Password",
    rp_confirm: "Confirm Password",
    rp_btn: "Reset Password",
    rp_done: "Password updated! You can now login with your new password.",
    rp_mismatch: "Passwords do not match",
    qr_title: "Scan & Pay",
    qr_upi: "UPI ID",
    qr_hint: "Pay via any UPI app, then add your deposit above",
    d_proof: "Payment Screenshot (required)",
    d_reference_id: "Reference ID / UTR Number",
    d_proof_choose: "Choose Image",
    dsad_history: "Payout History",
    dsad_hist_sub: "Month-wise payout record of your team business.",
    dsad_month: "Month",
    tab_payouts: "Payouts",
    adm_view_proof: "View Proof",
    adm_mark_paid: "Mark Paid",
    adm_mark_unpaid: "Mark Accrued",
    adm_no_payouts: "No payout records yet — snapshots are created nightly.",
    adm_dsa: "DSA",
    dsad_growth: "Business Growth",
    dsad_growth_sub: "Your team business, month by month.",
    msg_payout_paid: "Marked paid — receipt emailed to the DSA partner",
    notif_bell: "Notifications",
    notif_empty: "No notifications yet",
    notif_mark_read: "Mark all read",
    adm_charts_business: "Monthly Business",
    adm_charts_returns: "Returns Credited",
    d_growth: "Balance Over Time",
    d_growth_sub: "Your passbook balance, day by day.",
    tab_settings: "Settings",
    tab_offers: "Offers",
    adm_offers_title: "Landing Page Offers — Running Strip",
    adm_offer_en: "Offer text (English)",
    adm_offer_gu: "Offer text (Gujarati, optional)",
    adm_add_offer: "Add Offer",
    adm_no_offers: "No offers yet — add one and it appears instantly as a running strip on the first page",
    adm_show: "Show",
    adm_hide: "Hide",
    adm_delete: "Delete",
    msg_offer_added: "Offer added to landing page",
    wa_invest: "Invest on WhatsApp",
    wa_chat: "Chat on WhatsApp",
    adm_settings_title: "Payment Settings",
    adm_bank_details: "Bank Account Details",
    adm_alert_email: "Admin Alert Email (deposit / withdrawal / DSA alerts)",
    adm_bank_name: "Bank Name",
    adm_account_name: "Account Holder Name",
    adm_account_number: "Account Number",
    adm_ifsc: "IFSC Code",
    adm_upi_id: "UPI ID",
    adm_change_qr: "Change QR Image",
    adm_current_qr: "Current QR",
    adm_save: "Save Settings",
    msg_settings_saved: "Payment settings saved",
    msg_qr_updated: "QR image updated",
    d_bank_details: "Bank Details",
  },
  gu: {
    nav_plans: "પ્લાન્સ",
    nav_calculator: "કેલ્ક્યુલેટર",
    nav_dsa: "DSA પાર્ટનર",
    nav_contact: "સંપર્ક",
    nav_login: "લોગિન",
    nav_join: "જોડાઓ",
    nav_dashboard: "મારું ડેશબોર્ડ",
    nav_logout: "લોગઆઉટ",
    hero_eyebrow: "મેટ્રિક્સ વર્ક્સ સર્વિસ પ્રા. લિ. · અમદાવાદ",
    hero_l1: "સુવર્ણ ભવિષ્ય માટે",
    hero_l2: "શ્રેષ્ઠ રોકાણ",
    hero_l3: "આયોજન",
    hero_sub: "નાણાકીય સુરક્ષા, વિશ્વસનીય વળતર અને તમારા ભવિષ્યનો સાચો સાથી. જાતે રોકાણ કરો, લાઈવ ગ્રોથ જુઓ અને સમયસર ઉપાડો.",
    hero_cta1: "પ્લાન્સ જુઓ",
    hero_cta2: "કેલ્ક્યુલેટર વાપરો",
    stat_years: "વર્ષોનો વિશ્વાસ",
    stat_clients: "સક્રિય ગ્રાહકો",
    stat_funds: "કુલ ફંડ મેનેજમેન્ટ",
    stat_turnover: "દૈનિક સરેરાશ ટર્નઓવર",
    marquee_1: "100% રિયલ-ટાઈમ ટ્રેકિંગ",
    marquee_2: "પારદર્શક એકાઉન્ટિંગ",
    marquee_3: "સમયસર વિડ્રોઅલ",
    marquee_4: "લેખિત MOU એગ્રીમેન્ટ",
    marquee_5: "દૈનિક લાઈવ ગ્રોથ",
    plans_eyebrow: "રોકાણ પ્લાન્સ",
    plans_title: "તમારી સંપત્તિ વધારવાના પાંચ માર્ગો",
    plans_sub: "નાની દૈનિક બચતથી લઈને માસિક ઊંચી આવક સુધી — દરેક પ્લાન લેખિત એગ્રીમેન્ટ સાથે.",
    p1_name: "ડેઇલી રિકરિંગ પ્લાન",
    p1_tag: "30 દિવસ · 10% ચોખ્ખો નફો",
    p1_desc: "ફક્ત ₹50 દરરોજથી શરૂ કરો. 7 દિવસમાં એકમુશ્ત જમા કરી શકાય. 30મા દિવસે વ્યાજ સાથે સંપૂર્ણ રકમ સીધી બેંકમાં.",
    p2_name: "ડેઇલી ROI પ્લાન",
    p2_tag: "1–2% દરરોજ · મૂડી પરત",
    p2_desc: "દરરોજ નિશ્ચિત આવક તમારા ખાતામાં. લઘુત્તમ વિડ્રોઅલ ₹500. મેચ્યોરિટી પર સંપૂર્ણ મૂળ મૂડી પરત.",
    p3_name: "મંथली ROI પ્લાન",
    p3_tag: "11–15% માસિક · 12 મહિના",
    p3_desc: "એક વાર રોકાણ કરો, દર મહિને પેન્શન જેવી આવક મેળવો. 12મા મહિને સંપૂર્ણ મૂળ મૂડી પરત.",
    p4_name: "ફિક્સ્ડ ડિપોઝિટ",
    p4_tag: "6 મહિના · સુરક્ષિત ગ્રોથ",
    p4_desc: "લેખિત ખાતરી અને સંપૂર્ણ કાનૂની એગ્રીમેન્ટ (MOU) સાથે નિશ્ચિત સમય મૂડી ગ્રોથ.",
    p5_name: "ગોલ્ડ રિકરિંગ પ્લાન",
    p6_name: "લોન પ્લાન સાથે રોકાણ",
    p6_tag: "દૈનિક ROI + લોન સુવિધા",
    p6_desc: "90 દિવસ માટે 1% દૈનિક (₹1 લાખથી 2%) કમાઓ, મૂડી પાછી મેળવો — અને માત્ર 10 દિવસમાં તમારા રોકાણના 3 ગણા સુધીની લોન 11% EMI પર મેળવો.",
    p5_tag: "સૌથી ઓછા ભાવે સોનું",
    p5_desc: "સ્માર્ટ અને સુરક્ષિત રિકરિંગ પ્લાન સાથે શ્રેષ્ઠ ભાવે સોનામાં બચત કરો.",
    plan_cta: "આ પ્લાન શરૂ કરો",
    calc_eyebrow: "પ્લાન કેલ્ક્યુલેટર",
    calc_title: "રોકાણ પહેલાં જ તમારું વળતર જુઓ",
    calc_sub: "સ્લાઈડર ખસેડો અને તમારી અંદાજિત આવક, નફો અને કુલ વળતર લાઈવ જુઓ.",
    calc_daily_deposit: "દૈનિક જમા",
    calc_investment: "રોકાણ રકમ",
    calc_duration: "સમયગાળો",
    calc_days: "દિવસ",
    calc_day: "દિવસ",
    calc_months: "મહિના",
    calc_month: "મહિનો",
    calc_rate: "વળતર દર",
    calc_daily_income: "દૈનિક આવક",
    calc_monthly_income: "માસિક આવક",
    calc_total_deposit: "કુલ જમા",
    calc_profit: "કુલ નફો",
    calc_total_return: "કુલ વળતર",
    calc_capital_back: "મેચ્યોરિટી પર મૂડી પરત",
    calc_cta: "હવે રોકાણ શરૂ કરો",
    dsa_eyebrow: "DSA પાર્ટનર પ્રોગ્રામ",
    dsa_title: "Matrix Works સાથે તમારો પોતાનો બિઝનેસ બનાવો",
    dsa_sub: "તમારો યુનિક DSA કોડ મેળવો, દરેક પે-આઉટ લાઈવ ટ્રેક કરો અને ટીમ વધે ત્યારે 14% સુધી કમાઓ.",
    dsa_join: "DSA પાર્ટનર બનો",
    dsa_f1: "અલગ DSA કોડ",
    dsa_f2: "લાઈવ પે-આઉટ ટ્રેકિંગ",
    dsa_f3: "રિન્યુઅલ બોનસ",
    dsa_f4: "1% ટીમ રેફરલ",
    slab_business: "માસિક બિઝનેસ",
    slab_payout: "પે-આઉટ",
    slab_renewal: "રિન્યુઅલ",
    slab_extra: "એક્સ્ટ્રા",
    slab_total: "કુલ",
    slab_upto: "સુધી",
    slab_above: "થી વધુ",
    sec_eyebrow: "100% સુરક્ષા",
    sec_title: "તમારા પૈસા, લેખિત સુરક્ષામાં",
    sec_sub: "અમે ફક્ત વાયદા કરતા નથી — અમે તમને સંપૂર્ણ સુરક્ષિત અને પારદર્શક સિસ્ટમ આપીએ છીએ.",
    sec1_t: "સંપૂર્ણ એગ્રીમેન્ટ (MOU)",
    sec1_d: "તમારા દરેક પ્લાન માટે લેખિત કાનૂની કરાર.",
    sec2_t: "સિક્યોરિટી બ્લેન્ક ચેક",
    sec2_d: "રોકાણની સુરક્ષા માટે કંપની તરફથી આપવામાં આવે છે.",
    sec3_t: "લાઈવ ડેશબોર્ડ",
    sec3_d: "તમારા મોબાઈલ/કમ્પ્યુટર પર દૈનિક ગ્રોથ લાઈવ દેખાશે.",
    sec4_t: "ઓન-ટાઈમ વિડ્રોઅલ",
    sec4_d: "નિયત સમય પર સીધી રકમ બેંક ખાતામાં જમા થાય છે.",
    trust_quote: "રોકાણ કરો અને નિશ્ચિંત ઊંઘો. અમે જે વળતર આપવાનું નક્કી કરીએ છીએ, તે લેખિતમાં આપીએ છીએ — તમારું રોકાણ તમારા જ હાથમાં સુરક્ષિત રહે છે.",
    trust_name: "Matrix Works વચન",
    contact_eyebrow: "સંપર્ક કરો",
    contact_title: "આજે જ રોકાણ શરૂ કરો, ઉજ્જ્વળ ભવિષ્ય સુરક્ષિત કરો",
    contact_sub: "અમારી ઓફિસે આવો અથવા કોલ કરો — અમારી ટીમ દરેક પ્લાન સરળ ભાષામાં સમજાવશે.",
    contact_call: "કોલ કરો",
    contact_office: "ઓફિસ સરનામું",
    footer_tag: "નાણાકીય સુરક્ષા · વિશ્વસનીય વળતર · તમારો સાચો સાથી",
    footer_rights: "© 2026 Matrix Works Service Pvt. Ltd. સર્વ હક અમારા.",
    login_title: "ફરી સ્વાગત છે",
    login_sub: "તમારા પ્લાન્સ અને રોજિંદી પાસબુક જોવા લોગિન કરો.",
    login_investor_title: "રોકાણકાર લોગિન",
    login_dsa_title: "DSA પાર્ટનર લોગિન",
    login_dsa_sub: "તમારા રેફરલ અને બિઝનેસ ડેશબોર્ડમાં લોગિન કરો.",
    login_dsa_badge: "DSA પાર્ટનર પોર્ટલ",
    login_dsa_new: "નવા DSA પાર્ટનર?",
    login_dsa_link: "DSA પાર્ટનર? અહીં લોગિન કરો",
    login_investor_link: "રોકાણકાર? અહીં લોગિન કરો",
    login_wrong_dsa: "આ DSA પાર્ટનર એકાઉન્ટ નથી. કૃપા કરી રોકાણકાર લોગિન પેજ વાપરો.",
    login_wrong_investor: "આ DSA પાર્ટનર એકાઉન્ટ છે. કૃપા કરી DSA પાર્ટનર લોગિન પેજ વાપરો.",
    nav_investor_login: "રોકાણકાર લોગિન",
    nav_dsa_login: "DSA લોગિન",
    loan_sec_title: "રોકાણ યોજના (Investment with Loan Plan)",
    loan_sec_sub: "નિયમિત રોકાણ કરો, વધુ વળતર મેળવો અને તમારી નાણાકીય જરૂરિયાત માટે લોન સુવિધાનો લાભ લો.",
    loan_hl_days: "90 દિવસનું ROI વળતર",
    loan_hl_loan: "માત્ર 10 દિવસમાં લોન સુવિધા",
    loan_hl_emi: "EMI માત્ર 11%",
    loan_hl_tenure: "12 / 24 / 36 / 60 મહિનાની સમય મુદત",
    loan_col_deposit: "રોકાણ રકમ (₹)",
    loan_col_daily: "દરરોજ ROI (₹)",
    loan_col_loan: "લોન રકમ (₹)",
    loan_col_tenure: "મુદત",
    loan_col_emi: "માસિક EMI (₹)",
    loan_col_profit: "કુલ પ્રોફિટ (₹)",
    loan_col_repay: "લોન કુલ ચુકવણી (₹)",
    loan_col_left: "90 દિવસ બાદ બાકી (₹)",
    loan_months: "મહિના",
    loan_note: "નોંધ: નિયમો અને શરતો કંપનીની નીતિ મુજબ લાગુ રહેશે. વધુ માહિતી માટે તમારા નજીકના બ્રાન્ચનો સંપર્ક કરો.",
    calc_loan_upto: "લોન પાત્રતા (સુધી)",
    d_loan_title: "લોન સુવિધા",
    d_loan_apply: "લોન માટે અરજી કરો",
    d_loan_eligible: "લોન પાત્રતા",
    d_loan_available: "ઉપલબ્ધ લોન રકમ",
    d_loan_need_plan: "લોન સુવિધા મેળવવા લોન પ્લાન સાથે રોકાણ શરૂ કરો (માત્ર 10 દિવસમાં લોન).",
    d_loan_none: "હજુ કોઈ લોન વિનંતી નથી",
    d_loan_requests: "મારી લોન વિનંતીઓ",
    d_emi: "માસિક EMI",
    d_tenure: "મુદત",
    d_months: "મહિના",
    msg_loan_submitted: "લોન વિનંતી મંજૂરી માટે મોકલાઈ",
    tab_loans: "લોન",
    adm_no_loans: "કોઈ લોન વિનંતી નથી",
    adm_emi_tenure: "EMI / મુદત",
    msg_loan_updated: "લોન સ્થિતિ અપડેટ થઈ",
    d_emi_pay: "EMI ભરો",
    d_emi_schedule: "EMI સમયપત્રક",
    d_emi_paid: "ભરાઈ",
    d_emi_verification: "ચકાસણીમાં",
    d_emi_pending: "બાકી",
    d_emi_overdue: "મુદત વીતી",
    d_emi_progress: "EMI ભરાઈ",
    d_emi_due: "દેવા તારીખ",
    msg_emi_submitted: "EMI ચુકવણી ચકાસણી માટે મોકલાઈ",
    adm_emi_verifications: "EMI ચુકવણી ચકાસણી",
    adm_emi_no: "EMI #",
    msg_emi_updated: "EMI સ્થિતિ અપડેટ થઈ",
    dsad_share_link: "તમારી રેફરલ લિંક",
    dsad_copy_link: "લિંક કોપી કરો",
    dsad_share_wa: "WhatsApp પર શેર કરો",
    dsad_share_msg: "Matrix Works Gold જોડાઓ — રોકાણ કરો અને દૈનિક વળતર + લોન સુવિધા મેળવો. મારી રેફરલ લિંકથી નોંધણી કરો:",
    msg_link_copied: "રેફરલ લિંક કોપી થઈ",
    msg_photo_uploaded: "ફોટો અપલોડ થયો",
    dsad_id_card: "મારું ID કાર્ડ",
    dsad_id_sub: "તમારો ફોટો અપલોડ કરો અને ઓફિશિયલ Matrix Works DSA ID કાર્ડ ડાઉનલોડ કરો.",
    dsad_upload_photo: "ફોટો અપલોડ કરો",
    dsad_download_id: "ID કાર્ડ ડાઉનલોડ કરો",
    dsad_photo_required: "પહેલા તમારો ફોટો અપલોડ કરો",
    d_photo: "ફોટો",
    adm_view: "જુઓ",
    adm_profile_title: "રોકાણકાર પ્રોફાઇલ",
    adm_joined: "જોડાયા",
    adm_balance: "બેલેન્સ",
    adm_plans: "પ્લાન્સ",
    adm_loans: "લોન",
    adm_payments: "જમા અને વિડ્રોઅલ",
    adm_passbook_recent: "તાજેતરની પાસબુક એન્ટ્રી",
    register_title: "તમારું એકાઉન્ટ બનાવો",
    register_sub: "ગ્રાહક અથવા DSA પાર્ટનર તરીકે નોંધણી કરો. એડમિન તમારું એકાઉન્ટ મંજૂર કરશે.",
    register_sub_customer: "તમારું રોકાણકાર એકાઉન્ટ બનાવો — તરત જ લોગિન કરો અને રોકાણ શરૂ કરો.",
    d_dash_sub: "તમારા પ્લાન્સ અને રોજિંદી પાસબુક જુઓ.",
    d_passbook: "પાસબુક",
    d_balance: "વર્તમાન બેલેન્સ",
    d_invested: "કુલ રોકાણ",
    d_returns: "કુલ વળતર",
    d_active: "સક્રિય પ્લાન્સ",
    d_date: "તારીખ",
    d_description: "વિગત",
    d_credit: "જમા",
    d_debit: "ઉધાર",
    d_amount: "રકમ",
    d_status: "સ્ટેટસ",
    d_plan: "પ્લાન",
    d_rate: "દર",
    d_expected: "અપેક્ષિત કુલ",
    d_my_investments: "મારા રોકાણો",
    d_add_deposit: "જમા ઉમેરો",
    d_withdraw: "વિડ્રોઅલ વિનંતી",
    d_bank_name: "બેંકનું નામ",
    d_ac_holder: "ખાતાધારકનું નામ",
    d_ac_number: "ખાતા નંબર",
    d_ifsc: "IFSC કોડ",
    d_new_investment: "નવું રોકાણ શરૂ કરો",
    d_full_name: "પૂરું નામ",
    d_email: "ઈમેલ ID",
    d_mobile: "મોબાઈલ નં",
    d_submit: "સબમિટ",
    d_note: "નોંધ (વૈકલ્પિક)",
    d_no_entries: "હજુ કોઈ એન્ટ્રી નથી",
    d_select_plan: "પ્લાન પસંદ કરો",
    d_download_pdf: "PDF ડાઉનલોડ",
    d_day_to_day: "રોજિંદી",
    k_investment: "પ્લાન સક્રિય",
    k_deposit: "જમા",
    k_return: "દૈનિક વળતર",
    k_withdrawal: "ઉપાડ",
    k_adjustment: "એડજસ્ટમેન્ટ",
    msg_inv_submitted: "રોકાણ વિનંતી મંજૂરી માટે મોકલાઈ",
    msg_dep_submitted: "જમા એડમિન મંજૂરી માટે મોકલાઈ",
    msg_wd_submitted: "વિડ્રોઅલ વિનંતી મોકલાઈ",
    dsad_title: "DSA બિઝનેસ પેજ",
    dsad_sub: "તમારું પોતાનું બિઝનેસ ડેશબોર્ડ — ટીમ, વોલ્યુમ અને પે-આઉટ.",
    dsad_your_code: "તમારો DSA કોડ",
    dsad_share_hint: "આ કોડ ગ્રાહકો સાથે શેર કરો — તેમનો બિઝનેસ તમારા સ્લેબમાં ગણાશે.",
    dsad_copy: "કોડ કોપી",
    dsad_copied: "DSA કોડ કોપી થયો",
    dsad_team_business: "ટીમ બિઝનેસ",
    dsad_current_slab: "વર્તમાન સ્લેબ",
    dsad_est_payout: "અંદાજિત પે-આઉટ",
    dsad_team_members: "ટીમ સભ્યો",
    dsad_breakdown: "પે-આઉટ વિગત",
    dsad_my_team: "મારી ટીમ",
    dsad_slab_progress: "સ્લેબ પ્રગતિ",
    dsad_slabs_title: "DSA બિઝનેસ સ્લેબ",
    dsad_you: "તમે",
    dsad_team_empty: "હજુ કોઈ ટીમ સભ્ય નથી — ટીમ વધારવા તમારો DSA કોડ શેર કરો.",
    d_name: "નામ",
    d_phone: "ફોન",
    d_business: "બિઝનેસ",
    adm_title: "એડમિન પેનલ",
    adm_sub: "મંજૂરીઓ, પ્લાન્સ, જમા અને દૈનિક વળતર મેનેજ કરો.",
    tab_overview: "ઓવરવ્યૂ",
    tab_users: "યુઝર્સ",
    tab_investments: "રોકાણો",
    tab_deposits: "જમા",
    tab_withdrawals: "વિડ્રોઅલ",
    tab_passbook: "પાસબુક",
    adm_total_business: "કુલ બિઝનેસ",
    adm_customers: "ગ્રાહકો",
    adm_dsa_partners: "DSA પાર્ટનર્સ",
    adm_active_plans: "સક્રિય પ્લાન્સ",
    adm_pending_users: "બાકી યુઝર્સ",
    adm_pending_plans: "બાકી પ્લાન્સ",
    adm_pending_deposits: "બાકી જમા",
    adm_pending_withdrawals: "બાકી વિડ્રોઅલ",
    adm_credit_btn: "આજનું દૈનિક વળતર ક્રેડિટ કરો",
    adm_approve: "મંજૂર",
    adm_reject: "નામંજૂર",
    adm_no_users: "કોઈ યુઝર નથી",
    adm_no_investments: "કોઈ રોકાણ નથી",
    adm_no_deposits: "કોઈ જમા નથી",
    adm_no_withdrawals: "કોઈ વિડ્રોઅલ નથી",
    adm_customer: "ગ્રાહક",
    adm_principal: "મૂડી",
    adm_action: "ક્રિયા",
    adm_email: "ઈમેઈલ",
    adm_role: "ભૂમિકા",
    adm_dsa_code: "DSA કોડ",
    adm_manual_title: "મેન્યુઅલ પાસબુક એન્ટ્રી ઉમેરો",
    adm_amount_hint: "રકમ (₹) — ઉધાર માટે ઋણ",
    adm_select_customer: "ગ્રાહક પસંદ કરો",
    adm_add_entry: "એન્ટ્રી ઉમેરો",
    adm_note: "નોંધ",
    msg_success: "સફળતાપૂર્વક પૂર્ણ",
    msg_credited_prefix: "દૈનિક વળતર ક્રેડિટ થયું:",
    msg_credited_suffix: "સક્રિય પ્લાન(્સ)",
    msg_entry_added: "પાસબુક એન્ટ્રી ઉમેરાઈ",
    gallery_eyebrow: "ઓફિશિયલ પ્લાન ચાર્ટ્સ",
    gallery_title: "કંપનીના ઓફિશિયલ રેટ ચાર્ટ્સ",
    gallery_sub: "દરેક પ્લાનના ઓફિશિયલ Matrixworks Gold પોસ્ટર — સંપૂર્ણ સાઈઝમાં જોવા કોઈપણ ચાર્ટ પર ક્લિક કરો.",
    k_capital_return: "મૂડી પરત",
    d_maturity: "મેચ્યોરિટી",
    fp_title: "પાસવર્ડ ભૂલી ગયા?",
    fp_sub: "તમારું રજિસ્ટર્ડ ઈમેઈલ નાખો — અમે તમને રીસેટ લિંક મોકલીશું.",
    fp_send: "રીસેટ લિંક મોકલો",
    fp_sent: "જો આ ઈમેઈલ રજિસ્ટર્ડ હોય તો રીસેટ લિંક મોકલાઈ ગઈ છે. તમારું ઇનબોક્સ ચેક કરો.",
    fp_back: "લોગિન પર પાછા",
    rp_title: "પાસવર્ડ રીસેટ",
    rp_sub: "તમારા એકાઉન્ટ માટે નવો પાસવર્ડ પસંદ કરો.",
    rp_new: "નવો પાસવર્ડ",
    rp_confirm: "પાસવર્ડ કન્ફર્મ",
    rp_btn: "પાસવર્ડ રીસેટ કરો",
    rp_done: "પાસવર્ડ અપડેટ થયો! હવે તમે નવા પાસવર્ડથી લોગિન કરી શકો છો.",
    rp_mismatch: "પાસવર્ડ મેળ ખાતા નથી",
    qr_title: "સ્કેન અને પે",
    qr_upi: "UPI ID",
    qr_hint: "કોઈપણ UPI એપથી પે કરો, પછી ઉપર તમારી જમા ઉમેરો",
    d_proof: "પેમેન્ટ સ્ક્રીનશોટ (ફરજિયાત)",
    d_reference_id: "રેફરન્સ ID / UTR નંબર",
    d_proof_choose: "ઈમેજ પસંદ કરો",
    dsad_history: "પે-આઉટ ઇતિહાસ",
    dsad_hist_sub: "તમારા ટીમ બિઝનેસનો માસિક પે-આઉટ રેકોર્ડ.",
    dsad_month: "મહિનો",
    tab_payouts: "પે-આઉટ્સ",
    adm_view_proof: "પ્રૂફ જુઓ",
    adm_mark_paid: "ચૂકવેલ",
    adm_mark_unpaid: "બાકી કરો",
    adm_no_payouts: "હજુ કોઈ પે-આઉટ રેકોર્ડ નથી — સ્નેપશોટ દરરોજ રાત્રે બને છે.",
    adm_dsa: "DSA",
    dsad_growth: "બિઝનેસ ગ્રોથ",
    dsad_growth_sub: "તમારો ટીમ બિઝનેસ, મહિના દર મહિને.",
    msg_payout_paid: "ચૂકવેલ — રસીદ DSA પાર્ટનરને ઈમેઈલ થઈ",
    notif_bell: "નોટિફિકેશન્સ",
    notif_empty: "હજુ કોઈ નોટિફિકેશન નથી",
    notif_mark_read: "બધું વાંચેલું કરો",
    adm_charts_business: "માસિક બિઝનેસ",
    adm_charts_returns: "ક્રેડિટ વળતર",
    d_growth: "સમય સાથે બેલેન્સ",
    d_growth_sub: "તમારું પાસબુક બેલેન્સ, દિવસે દિવસે.",
    tab_settings: "સેટિંગ્સ",
    tab_offers: "ઓફર્સ",
    adm_offers_title: "લેન્ડિંગ પેજ ઓફર્સ — રનિંગ સ્ટ્રિપ",
    adm_offer_en: "ઓફર ટેક્સ્ટ (English)",
    adm_offer_gu: "ઓફર ટેક્સ્ટ (ગુજરાતી, વૈકલ્પિક)",
    adm_add_offer: "ઓફર ઉમેરો",
    adm_no_offers: "હજુ કોઈ ઓફર નથી — એક ઉમેરો એટલે તે તરત જ પ્રથમ પેજ પર રનિંગ સ્ટ્રિપમાં દેખાશે",
    adm_show: "બતાવો",
    adm_hide: "છુપાવો",
    adm_delete: "દૂર કરો",
    msg_offer_added: "ઓફર લેન્ડિંગ પેજ પર ઉમેરાઈ",
    wa_invest: "WhatsApp પર રોકાણ કરો",
    wa_chat: "WhatsApp પર ચેટ કરો",
    adm_settings_title: "પેમેન્ટ સેટિંગ્સ",
    adm_bank_details: "બેંક એકાઉન્ટ વિગતો",
    adm_alert_email: "એડમિન એલર્ટ ઈમેલ (ડિપોઝિટ / વિડ્રોઅલ / DSA એલર્ટ)",
    adm_bank_name: "બેંકનું નામ",
    adm_account_name: "એકાઉન્ટ હોલ્ડરનું નામ",
    adm_account_number: "એકાઉન્ટ નંબર",
    adm_ifsc: "IFSC કોડ",
    adm_upi_id: "UPI ID",
    adm_change_qr: "QR ઈમેજ બદલો",
    adm_current_qr: "વર્તમાન QR",
    adm_save: "સેટિંગ્સ સાચવો",
    msg_settings_saved: "પેમેન્ટ સેટિંગ્સ સાચવાઈ",
    msg_qr_updated: "QR ઈમેજ અપડેટ થઈ",
    d_bank_details: "બેંક વિગતો",
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const t = (key) => translations[lang][key] ?? translations.en[key] ?? key;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
